import { Injectable } from '@angular/core';
import type { EavEntityTypeFindManyQueryInterface } from '@zaoblako/shared/modules/eav/dtos/entity-type/eav-entity-type-find-many-query.dto';
import type { EavEntityTypeFindInterface } from '@zaoblako/shared/modules/eav/dtos/entity-type/eav-entity-type-find.dto';
import type { EavEntityTypePageInterface } from '@zaoblako/shared/modules/eav/dtos/entity-type/eav-entity-type-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelpDeskEavEntityTypeService extends BaseService {
  protected baseUrl = '/helpdesk/eav-entity-type';

  public findWithPagination(queryParams: EavEntityTypeFindManyQueryInterface): Observable<EavEntityTypePageInterface> {
    return this.http.get<EavEntityTypePageInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public restoreOne(id: number): Observable<EavEntityTypeFindInterface> {
    return this.http.post<EavEntityTypeFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }
}
